import Touchable from '@components/Touchable'
import { Avatar, Icon, Paper, Stack, Typography } from '@mui/material'
import React from 'react'

interface IProps {
  title: string
  visual: string
  description?: string
  size?: 'small' | 'large'
  onClick?: () => void
}

export const DiscoverButton = ({ title, visual, description, size = 'small', onClick }: IProps) => {
  if (size === 'small') {
    return (
      <Touchable style={{ flex: 1, display: 'flex' }} onClick={onClick}>
        <Stack flex={1}>
          <Stack
            py={1}
            px={2}
            flex={1}
            justifyContent="space-between"
            alignItems="center"
            direction="row"
            bgcolor="background.paper"
            borderRadius={2}
          >
            <Typography variant="body2">{title}</Typography>
            <Avatar
              sx={{
                width: 50,
                height: 50,
              }}
              src={visual}
            />
          </Stack>
        </Stack>
      </Touchable>
    )
  }

  return (
    <Touchable onClick={onClick}>
      <Stack flexGrow={1}>
        <Stack
          sx={{
            background: `url(${visual})`,
            backgroundColor: (theme) => theme.palette.background.paper,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center right',
          }}
          py={2}
          pl={2}
          pr={4}
          flexGrow={1}
          justifyContent="space-between"
          alignItems="center"
          direction="row"
          borderRadius={2}
        >
          <Stack direction="column">
            <Typography variant="body2" gutterBottom={true} fontWeight="bold">
              {title}
            </Typography>
            <Typography variant="body1">{description}</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Touchable>
  )
}
